import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { N700 } from "@atlaskit/theme/colors";

import AccountCreation from "@/components/signup/account-creation";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { EmbeddedSignupModuleWrapper } from "../../../embedded-signup-module-wrapper";
import { EmailForm, ExistingProductText } from "../components";
import { useSignupFormContext } from "../hooks";

export const DefaultEmbeddedSignupForm = () => {
    const { showProductLogo, productLogos, productName } =
        useSignupFormContext();

    const deprecateEmbeddedSignupModule = checkFeatureFlagGate(
        featureFlags.signupDeprecateEmbeddedSignupModule
    );

    return (
        <EmbeddedSignupModuleWrapper>
            <div css={containerStyle} data-testid="signup-form">
                {showProductLogo && (
                    <div css={productLogoCss}>
                        {productLogos.map((ProductLogo, index) => (
                            <ProductLogo appearance="brand" key={index} />
                        ))}
                    </div>
                )}
                <h1>
                    <FormattedMessage
                        id="BxpUiSignup.EmbeddedSignupForm.header"
                        defaultMessage="Get started with {product}"
                        values={{ product: productName }}
                    />
                </h1>
                <h2>
                    <FormattedMessage
                        id="BxpUiSignup.EmbeddedSignupForm.subheader.1"
                        defaultMessage="It's free for up to 10 users — no credit card needed."
                    />
                </h2>
                {deprecateEmbeddedSignupModule ? (
                    <AccountCreation Login={null} />
                ) : (
                    <EmailForm />
                )}
                <ExistingProductText productName={productName} />
            </div>
        </EmbeddedSignupModuleWrapper>
    );
};

const containerStyle = css({
    alignItems: "stretch",
    color: N700,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});

const productLogoCss = css({
    display: "flex",
    justifyContent: "center",
    marginBlockEnd: 20
});
